export default {
  methods: {
    addPWA: function () {
      try {
        window.deferredPrompt.prompt();
        window.deferredPrompt.userChoice.then(choiceResult => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          window.deferredPrompt = null;
        });
      } catch (TypeError) {
        this.$app.dialog.alert('Can\'t install now. For iOS devices : Go to SHARE > ADD TO HOME SCREEN');
      }
    },
    syncData: function () {
      if (!window.app.f7.online) {
        window.app.f7.dialog.alert('Device Offline!');
        return;
      }
      if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
        window.app.f7.dialog.alert('Please Sign In!');
        return;
      }
      this.$app.toast.create({
        text: 'Syncing App Data',
        closeTimeout: 2000
      }).open();
      window.app.f7.methods.syncAppData(true);
    },
    forceUpdate: function () {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(registrations => {
          for (let registration of registrations) {
            registration.update().then(() => {
              window.location.reload(true);
            });
          }
          ;
        });
      }
      ;
    }
  },
  id: '30f2ac253c',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n<div class="page" data-name="settings">\n  <div class="navbar">\n    <div class="navbar-bg"></div>\n    <div class="navbar-inner sliding">\n      <div class="title">Settings</div>\n    </div>\n  </div>\n  <div class="page-content">\n    <div class="block-title">Account</div> \n    <div class="block block-strong">\n      <div class="page-content" id="accInfo">\n      </div>\n      <p class="row" id="g-login-bttn">\n          <a href="#" class="col button button-large button-fill button-raised color-green" id="g-signin" onclick="handleSignInClick()">Login</a>\n      </p>\n    </div>\n    <div class="block-title">Classes</div>\n    <div class="block block-strong">\n      <p class="row">\n        <a href="/addclass/" class="col button button-raised button-fill">Add Class</a>\n        <a href="/newclass/" class="col button button button-fill button-raised color-green" id="create-class-bttn">Create Class</a>\n      </p>\n    </div>\n    <div class="list links-list">\n      <ul>\n          <li><a class="link external" href="/help.pdf">Help</a></li>\n          <li><a href="/license/">License</a></li>\n          <li><a href="/about/">About</a></li>\n      </ul>\n    </div>\n    <div class="block-title">App</div>\n    <div class="block block-strong">\n      <a href="#" class="col button button-raised color-orange" id="syncdataBTTN" @click="syncData">Restore App Data</a>\n      <br>\n      <a href="#" class="col button button-raised color-green disabled" id="installPWABTTN" @click="addPWA">Install App</a>\n      <br>\n      <a href="#" class="col button button-raised color-red" @click="forceUpdate">Force Update</a>\n    </div>\n    <p class="footer text-align-center disabled">AttnSheet by Soumyadip Mondal<br>Version : 1.0RC9</p>\n  </div>\n</div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};